import { useState, useEffect, useCallback } from 'react';

/**
 * 验证码倒计时 hook
 * @param seconds 倒计时秒数，默认 60
 * @returns [countdown, startCountdown] — 当前剩余秒数 + 启动函数
 */
export function useCountdown(seconds: number = 60): [number, () => void] {
    const [countdown, setCountdown] = useState(0);

    useEffect(() => {
        if (countdown <= 0) return;
        const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown]);

    const start = useCallback(() => {
        setCountdown(seconds);
    }, [seconds]);

    return [countdown, start];
}
